<script setup>
import { useHead } from "@unhead/vue";
import { ref, toValue, defineComponent, h } from "vue";

import Faq from "../scripts/components/Faq.vue";

useHead({
	title: "Your Custom Swag Questions Answered: Swagger's Frequently Asked Questions",
	meta: [
		{ name: "description", content: "Find answers to frequently asked questions about custom swag, branded merchandise, & working with Swagger. Get informed & start creating today!" },
		{ rel: "canonical", href: "https://giveswagger.com/faqs" },
		{ property: "og:title", content: "Your Custom Swag Questions Answered: Swagger's Frequently Asked Questions" },
		{ property: "og:description", content: "Find answers to frequently asked questions about custom swag, branded merchandise, & working with Swagger. Get informed & start creating today!" },
		{ property: "og:image", content: "https://giveswagger.com/assets/swagger-social.jpg" },
		{ property: "og:url", content: "https://giveswagger.com/faqs" }
	]
})

</script>

<template lang="pug">

.page.page--faqs
	header.page__header
		h1 FAQs
	.page__content
		section.section.section--faqs
			.section__content
				.faqs
					faq
						p Why Swagger?
						template(#content)
							p Three things–no, make that four! True style. 100% sustainable. Best quality. Always on budget. We make it easy – what's not to love?
					faq
						p What art files do you need?
						template(#content)
							p Just send the highest resolution artwork you have to us at <a href="mailto:orders@giveswagger.com">orders@giveswagger.com</a>. And don't stress, we'll resolve any resolution issues prior to going into production. Preferred file types include: ai, esp, jpg, svg, pdf – but we can take whatever you've got to get started.
					faq
						p Do you keep my art on file?
						template(#content)
							p Yes. That way, it's ready for your next Swagger order.
					faq
						p Can I get product samples?
						template(#content)
							p You bet! Product samples are available upon request.
					faq
						p Will I see a proof prior to production?
						template(#content)
							p Absolutely! We wouldn't have it any other way. Digital proofs ensure you get precisely what you ordered. And we never press GO without your approval.
					faq
						p Can I ship to multiple locations?
						template(#content)
							p Yep, no problem. Ship away!
					faq
						p Can I ship on my shipping account?
						template(#content)
							p Love the way you think. Yes, we are happy to ship using your existing account. See below for our shipping partners.
					faq
						p What shipping company do you use?
						template(#content)
							p DOMESTIC (USA) Shipping Partners: FedEx, UPS, USPS
							p INTERNATIONAL Shipping Partners: FedEx, DHL
					faq
						p What types of payments do you accept?
						template(#content)
							p Pay your way. We accept all major credit cards, debit cards, ACH and wire transfers.
					faq
						p When do I pay for my order?
						template(#content)
							p Our two-part invoice process couldn't be simpler. First payment of 75% due upon approval of proof and before production starts. Balance due at time of shipment.
					faq
						p If my company is tax-exempt, how do I place a tax-exempt order?
						template(#content)
							p Tax-exempt? Lucky you! Just email your current tax-exempt certificate to <a href="mailto:orders@giveswagger.com">orders@giveswagger.com</a>. Please write your company name in the email subject line and we'll take care of the rest–and keep it on file for future orders.
					faq
						p What if I'm not happy with my order?
						template(#content)
							p We're not happy until you're happy. Which is why we'll work with you to make it right.
					faq
						p Can I cancel or change my order?
						template(#content)
							p Budget cuts? Shifting priorities? Cold feet? We get it–and are happy to alter or cancel any order prior to going into production.

</template>